import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.span`
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;

  > svg {
    margin-right: 2px;
    vertical-align: -4px;

    path {
      fill: currentColor;
    }
  }
`;

/**
 * @type {React.FC<{ icon: any, mediaList?: unknown[] }>}
 */
const MediaCounter = ({ icon: Icon, mediaList }) =>
  mediaList && mediaList.length > 0 ? (
    <Wrapper>
      <Icon size={18} />
      {mediaList.length}
    </Wrapper>
  ) : null;

MediaCounter.propTypes = {
  icon: PropTypes.any.isRequired,
  mediaList: PropTypes.array,
};

MediaCounter.defaultProps = {
  mediaList: null,
};

export default MediaCounter;
